export default __webpack_public_path__ + "static/Premium Table - EzyMedical (EV)-30927083ad54e6a8310b8670d04b0a4e.pdf";